<template>
  <div class="PlanContent">
    <!-- 首頁圖 -->
    <div class="banner">
      <h1>{{ $t("home.plan_tit") }}</h1>
      <div class="banner-other">
        <span v-for="item in planData.banner_tit" :key="item">{{ item }}</span>
      </div>
    </div>
    <!-- 主要內容 -->
    <div class="content-container">
      <!-- 標題 -->
      <div class="title" ref="eligibility">
        <span>{{ $t("home.apply_require") }}</span>
      </div>
      <!-- 條件步驟 -->
      <div class="content-top-container">
        <p class="steps-star" v-html="planData.eligibility.con"></p>
        <!-- 經濟條件 -->
        <span>{{ planData.eligibility.financial_tit }}</span>
        <ul class="steps-list">
          <li
            v-for="(item, index) in planData.eligibility.financial"
            :key="index"
          >
            <span class="steps-num">{{ index + 1 }}</span>
            <p>{{ item }}</p>
          </li>
        </ul>
        <!-- 非經濟條件 -->
        <span>{{ planData.eligibility.non_financial_tit }}</span>
        <div class="other-steps-container">
          <ul class="steps-list other-steps-list">
            <li
              v-for="(item, index) in planData.eligibility.non_financial"
              :key="index"
            >
              <span class="steps-num">{{ index + 1 }}</span>
              <p>{{ item }}</p>
            </li>
          </ul>
          <div class="img-show">
            <img src="../assets/img/plan/pic1.jpg" alt="" />
          </div>
        </div>
        <p class="steps-end">
          {{ planData.eligibility.tips }}
        </p>
      </div>
      <!-- 計劃內容 -->
      <div class="content-plan-container" ref="overview">
        <div class="left-item">
          <p class="title">{{ planData.content_plan.title }}</p>
          <div class="border"></div>
          <p class="content">
            {{ planData.content_plan.content }}
          </p>
          <p class="con">{{ planData.content_plan.tips }}</p>
        </div>
        <ul class="right-item">
          <li v-for="item in planData.content_plan.content_item" :key="item">
            <span class="right-item-logo"></span>
            <p class="con">
              {{ item }}
            </p>
          </li>
        </ul>
      </div>
      <!-- 計劃細節 -->
      <div class="details-plan-container">
        <div class="details-plan-item details-plan-left">
          <p class="title">{{ planData.details_plan.title }}</p>
          <div class="border"></div>
          <ul class="details-list">
            <li v-for="item in planData.details_plan.content_item" :key="item">
              <i class="list-mark"></i>
              <p class="list-con" v-html="item"></p>
            </li>
          </ul>
        </div>
        <div class="details-plan-item details-plan-right">
          <div class="img-show">
            <img src="../assets/img/plan/pic3.png" alt="" srcset="" />
          </div>
          <p class="title">{{ planData.responsibilities_plan.title }}</p>
          <div class="border"></div>
          <ul class="details-list">
            <li
              v-for="item in planData.responsibilities_plan.content_item"
              :key="item"
            >
              <i class="list-mark"></i>
              <p class="list-con">
                {{ item }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 口號 -->
    <CommonSlogan />
  </div>
</template>

<script>
// import CoButton from "../components/co-button/co-button.vue";
import CommonSlogan from "../components/CommonSlogan.vue";
export default {
  name: "PlanContent",
  data() {
    return {
      locale: window.localStorage.getItem("locale"),
    };
  },
  components: { CommonSlogan },
  computed: {
    planData: function() {
      return this.$t("plan");
    },
  },
  // 锚点跳转
  mounted: function() {
    var hash = window.location.hash;
    var index = hash.lastIndexOf("#");
    var domH;
    var dom = hash.substring(index + 1, hash.length + 1);
    if (this.$refs[dom]) {
      domH = this.$refs[dom].offsetTop;
    } else {
      domH = 0;
    }
    // chrome
    document.body.scrollTop = domH;
    // firefox
    document.documentElement.scrollTop = domH;
    // safari
    window.pageYOffset = domH;
  },
};
</script>

<style scoped lang="scss">
.PlanContent {
  .banner {
    background-image: url("../assets/img/plan/1.jpg");
    padding-top: 48px;
    display: block;
    text-align: center;
    h1 {
      padding-bottom: 48px;
    }
    .banner-other {
      text-align: center;
      line-height: 35px;
      & > span {
        width: 80%;
        display: inline-block;
        font-size: 16px;
      }
    }
  }
  .content-container {
    font-size: 14px;
    .btn-nav {
      display: flex;
      justify-content: space-around;
      margin: 42px 0;
    }
    .content-top-container {
      overflow: hidden;
      border-bottom: solid 1px #e5e8e8;
      margin-top: 2.4vw;
      .steps-star {
        line-height: 24px;
        font-size: 16px;
      }
      & > span {
        display: block;
        color: #22a0d5;
        font-size: 16px;
      }
      .steps-num {
        font-size: 56px;
        color: #229fd8;
      }
      .steps-list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
        justify-content: space-around;
        & > li {
          width: 45%;
          display: flex;
          align-items: center;
          margin-bottom: 50px;
          p {
            color: #6c6f71;
            padding-left: 25px;
          }
        }
      }
      .other-steps-container {
        display: flex;
        margin-top: 20px;
        .other-steps-list {
          background: #e7f4dd;
          margin: 0;
          padding: 20px 0 0 40px;
          width: 50%;
          .steps-num {
            color: #85c358;
          }
          & > li {
            width: 100%;
            margin-bottom: 20px;
            & > p {
              padding: 0 0 0 1.5vw;
            }
          }
        }
        .img-show {
          display: inherit;
          overflow: hidden;
          & > img {
            width: 537px;
            height: 400px;
          }
        }
      }
      .steps-end {
        font-size: 16px;
        margin: 45px 0;
      }
    }
    .content-plan-container {
      margin: 1.8vw 0 2.6vw;
      border-radius: 0 25px 25px 0;
      display: flex;
      overflow: hidden;
      font-size: 16px;
      line-height: 24px;
      .left-item {
        width: 50%;
        background-image: url("../assets/img/plan/pic2.jpg");
        background-size: cover;
        background-repeat: no-repeat;
        color: white;
        padding: 4vw 3.5vw;
        box-sizing: border-box;
        .title {
          font-weight: 600;
          border: none;
          color: white;
          margin: 0;
        }
        .border {
          height: 4px;
          width: 36%;
          margin: 1.4vw 0 2.2vw 0;
          background: #85c358;
        }
        .con {
          padding-top: 20px;
          font-size: 12px;
        }
      }
      .right-item {
        width: 50%;
        background: #85c358;
        display: flex;
        flex-wrap: wrap;
        & > li {
          display: flex;
          position: relative;
          align-items: center;
          padding: 20px 20px 20px 0;
          .right-item-logo {
            width: 2.5vw;
            height: 3px;
            border-radius: 3px;
            transform: rotate(-45deg);
            background: #d6e122;
            position: absolute;
            top: 50%;
            left: 2%;
          }
          .con {
            color: white;
            padding-left: 4vw;
          }
        }
        & > li:nth-child(even) {
          background: #229fd8;
        }
      }
    }
    .details-plan-container {
      display: flex;
      justify-content: space-between;
      margin-bottom: 7vw;
      .details-plan-item {
        width: 48%;
        border-radius: 10px;
        box-shadow: 0px 3px 5px 5px #ccc;
        padding: 3.4vw 2.5vw;
        box-sizing: border-box;
        .title {
          margin: 0;
        }
        .border {
          width: 36%;
          height: 4px;
          background: #22a0d6;
          margin: 1.4vw 0 2.9vw;
        }
        .details-list {
          padding: 0 1.6vw;
          box-sizing: border-box;
          line-height: 24px;
          & > li {
            margin-bottom: 2.2vw;
            position: relative;
            .list-mark {
              left: -1.6vw;
              top: 0.4vw;
            }
          }
        }
      }
      .details-plan-right {
        padding: 1.3vw;
        box-sizing: border-box;
        .title {
          margin-top: 4.2vw;
        }
        .border {
          width: 50%;
          margin: 1.4vw 0 2.8vw;
        }
        .img-show {
          & > img {
            width: 100%;
            border-radius: 25px;
          }
        }
        .details-list > li {
          margin-bottom: 1.5vw;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .PlanContent {
    .banner {
      padding-top: unset;
      h1 {
        padding: 10px 0 0 0;
      }
      .banner-other {
        line-height: unset;
        & > span {
          width: 90%;
          font-size: 14px;
        }
      }
    }
    .content-container {
      margin: 0 auto;
      font-size: 12px;
      .title {
        color: #85c456;
        margin: 3.4vw auto 2.8vw;
        font-size: 5vw;
        & > span {
          border-bottom: solid 0.5vw #22a0d6;
          padding-bottom: 1vw;
        }
      }
      .content-top-container {
        overflow: hidden;
        border-bottom: solid 1px #e5e8e8;
        margin-top: 2.4vw;
        .steps-num {
          font-size: 40px;
          color: #229fd8;
        }
        .steps-list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 2.5vw;
          & > li {
            align-items: center;
            margin-bottom: 10px;
            p {
              width: 34vw;
              color: #6c6f71;
              padding: 1.8vw 0 0 1.5vw;
            }
          }
        }
        .other-steps-container {
          flex-wrap: wrap;
          .other-steps-list {
            flex-wrap: wrap;
            padding: 10px;
            width: auto;
            & > li {
              display: flex;
              width: 50%;
              align-items: center;
            }
          }
          .img-show {
            width: auto;
            & > img {
              height: auto;
              width: 100%;
            }
          }
        }
        .steps-end {
          line-height: 6vw;
          font-size: 3vw;
        }
      }
      .content-plan-container {
        flex-wrap: wrap;
        border-radius: 0 0 25px 25px;
        .left-item {
          width: 100%;
        }
        .right-item {
          width: 100%;
          & > li {
            position: relative;
            padding: 20px 10px 20px 0;
            .right-item-logo {
              width: 7.5vw;
            }
            .con {
              padding-left: 10vw;
            }
          }
          & > li:nth-child(even) {
            background: #229fd8;
          }
        }
      }
      .details-plan-container {
        display: block;
        /* justify-content: space-between; */
        margin-bottom: 6vw;
        .details-plan-item {
          width: 100%;
          border-radius: 25px;
          box-shadow: 0px 3px 5px 5px #ccc;
          padding: 3.4vw 2.5vw;
          box-sizing: border-box;
          margin-top: 6vw;
          .title {
            margin: 0;
          }
          .border {
            width: 27%;
            height: 4px;
            background: #22a0d6;
            margin: 1.4vw 0 2.9vw;
          }
          .details-list {
            padding: 0 2vw;
            box-sizing: border-box;
            & > li {
              margin-bottom: 4vw;
              position: relative;
              .list-mark {
                height: 4vw;
                left: -1.6vw;
                top: 1vw;
              }
              .list-con {
                font-size: 3vw;
                line-height: 6vw;
              }
            }
          }
        }
        .details-plan-right {
          padding: 1.3vw;
          box-sizing: border-box;
          .title {
            margin-top: 4.2vw;
          }
          .border {
            width: 50%;
            margin: 1.4vw 0 2.8vw;
          }
          .img-show {
            width: 100%;
            height: 86vw;
            // background-image: url("/img/pic3.80f47e6c.png");
            background-size: cover;
            background-repeat: no-repeat;
            border-radius: 25px;
          }
          .details-list > li {
            margin-bottom: 6vw;
          }
        }
      }
    }
  }
}
</style>
